import { createSlice } from "@reduxjs/toolkit";
import { getResellerList } from "./ThunkAction";
import { iResellerState, REDUCER_NAME } from "./Types"; 

// Define initial state based on the provided structure
const initialState: iResellerState = {
  isLoading: false,
  resellerList: [], 
  errorMessage: null,

};
export const resellerSlice = createSlice({
  name: REDUCER_NAME, 
  initialState,
  reducers: {
    resetResellerState: () => {
      return initialState; 
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getResellerList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getResellerList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.resellerList = payload.data.data; 
          state.isLoading = false;
        }
      })
      .addCase(getResellerList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch customer data";
        state.isLoading = false;
      });
  },
});

export const { resetResellerState} = resellerSlice.actions;
export default resellerSlice.reducer;
